<div
  [ngClass]="['tooltip--'+position]"
  [style.left]="left + 'px'"
  [style.top]="top + 'px'"
  [style.z-index]="zIndex"
  class="tooltip">
  {{tooltip}}
</div>
